import { render, staticRenderFns } from "./AlunosPendentes.vue?vue&type=template&id=38be4740&"
import script from "./AlunosPendentes.vue?vue&type=script&lang=js&"
export * from "./AlunosPendentes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports